import React, { Component } from 'react'

export default class DashboardLink extends Component {
    state = {
        links: [
            { img: "https://yonnect.com/assets/header/dashboard.png", link: 'https://yonnect.com/academy', title: "Academy", des: "In publishing and graphic design, text commonly " },
            { img: "https://yonnect.com/assets/header/hubs.png", link: 'https://yonnect.com/documents', title: "Documents", des: " graphic design, Lorem ipsum is a placeholder text commonly " },
            { img: "https://yonnect.com/assets/header/somthing.svg", link: 'https://yonnect.com/developers', title: "Developers", des: "In publishing graphic design, Lorem ipsum is a placeholder" },
            { img: "https://yonnect.com/assets/header/applet.png", link: 'https://yonnect.com/usecases', title: "Usecases", des: "In publishing and design, Lorem ipsum is commonly " },
            { img: "https://yonnect.com/assets/header/download.png", link: 'https://yonnect.com/download', title: "Download", des: "In publishing and graphic design, placeholder text commonly " },
            { img: "https://yonnect.com/assets/header/support.png", link: 'https://yonnect.com/faq', title: "Help center", des: "In publishing ipsum is a placeholder text commonly " },
            { img: "https://yonnect.com/assets/header/integrations.png", link: 'https://yonnect.com/pricing', title: "Pricing", des: "In Lorem ipsum is a placeholder text commonly " },
            { img: "https://yonnect.com/assets/header/about-yonnect.png", link: 'https://yonnect.com/about_yonnect', title: "Why Yonnect", des: "In publishing  Lorem ipsum is a placeholder text commonly " },

        ]
    }


    componentDidMount() {
        // this.init()
        // console.log('this.props.inbox', this.props.inbox)
        this.main.addEventListener('wheel', this.onWheel, true)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.data?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.main.removeEventListener('wheel', this.onWheel)

    }

    onWheel = (e) => {
        e.stopPropagation()
    }



    render() {
        return (
            <div className='dashboard-widgets ' >
                <div ref={el => this.main = el} style={{ maxHeight: 320, overflow: "scroll" }}>
                    <div className='p-3 pb-2 mb-2' style={{borderBottom:'1px solid #eee'}}>
                        <p className='text-semibig' style={{ fontWeight: "600" }}>Explore more</p>
                        {/* <p className='font-size-12 weight-400 color-gray-2 mt-1'>
                            You can use the links blow to get more information about Yonnect
                        </p> */}
                    </div>
                    <div className=' ' >
                        <div className='px-3 pt-1'>
                            {this.state.links.map((item, index) => {
                                return (
                                    <div  key={index} className='mb-3 pb-2 d-flex' style={{ borderBottom: "0px solid #e9e9e9" }}>

                                        <div>
                                            <img style={{ width: 40, height: 40, borderRadius: 7, objectFit: "cover" }} src={item.img} />
                                        </div>
                                        <div className='mld-4'>
                                            <div>
                                                <p className='font-size-16 text-bold'>{item.title}</p>
                                                <p className='font-size-12 weight-400 color-gray-2 line-clamp2 mt-1' >{item.des} Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis porro ipsa mollitia vel</p>
                                            </div>
                                            <a href={item.link} target='_blank' className='mt-1 flexc' style={{}}>
                                                <p className='font-size-13 weight-400 mrd-2' style={{ whiteSpace: "nowrap", color: "#0056ff" }}>
                                                    Visit Web Page
                                                </p>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.7" stroke="#0056ff" style={{ width: 17 }}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
                                                </svg>

                                            </a>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
